<template>
	<div class="tw-flex-1">
		<b-container fluid class="tw-text-black tw-mt-20">
			<div class="tw-flex">
				<div class="tw-w-96 tw-flex-none tw-text-justify">
					<h2 class="tw-text-3xl tw-font-bold tw-text-black">Ingreso Datos</h2>
					<validation-observer v-slot="{handleSubmit}" ref="formValidator">
						<b-form role="form" class="tw-mt-7" @submit.prevent="handleSubmit(onSubmit)">
							<!-- Select Cliente -->
							<base-input
								alternative
								name="Cliente"
								label="Cliente"
								class="tw-mt-3"
								label-classes="tw-px-3 tw-mb-1"
								group-class="mb-0 tw-bg-white tw-rounded tw-bg-opacity-60"
								:rules="{ required: true }"
								v-model="request.client"
								@input="errorMessage = null"
							>
								<multiselect
									label="client"
									track-by="id"
									placeholder="Cliente"
									:options="$clients.data"
									v-model="request.client"
								></multiselect>
							</base-input>

							<base-input
								alternative
								name="uniqueNumber"
								label="Numero Unico"
								class="tw-mt-3"
								label-classes="tw-px-3 tw-mb-1"
								group-class="mb-0 tw-bg-white tw-rounded tw-bg-opacity-60"
								:rules="{required: true}"
								placeholder="Ingrese Numero Unico"
								v-model="request.uniqueNumber"
								@input="errorMessage = null"
							/>

							<base-input
								alternative
								name="description"
								label="Descripcion"
								class="tw-mt-3"
								label-classes="tw-px-3 tw-mb-1"
								group-class="mb-0 tw-bg-white tw-rounded tw-bg-opacity-60"
								:rules="{required: true}"
								placeholder="Ingrese Descripcion"
								v-model="request.description"
								@input="errorMessage = null"
							/>

							<!-- Direction -->
							<base-input
								alternative
								name="direction"
								label="Direccion"
								class="tw-mt-3"
								label-classes="tw-px-3 tw-mb-1"
								group-class="mb-0 tw-bg-white tw-rounded tw-bg-opacity-60"
								:rules="{required: true}"
								placeholder="Ingrese Direccion"
								v-model="request.direction"
								@input="errorMessage = null"
							/>

							<div class="tw-flex tw-space-x-3 tw-mt-3">
								<!-- Town -->
								<base-input
									alternative
									name="town"
									label="Ciudad"
									class="tw-flex-1"
									label-classes="tw-px-3 tw-mb-1"
									group-class="mb-0 tw-bg-white tw-rounded tw-bg-opacity-60"
									:rules="{required: true}"
									placeholder="Ingrese Ciudad"
									v-model="request.town"
									@input="errorMessage = null"
								/>

								<!-- Province -->
								<base-input
									alternative
									name="province"
									label="Provincia"
									class="tw-flex-1"
									label-classes="tw-px-3 tw-mb-1"
									group-class="mb-0 tw-bg-white tw-rounded tw-bg-opacity-60"
									:rules="{required: true}"
									placeholder="Ingrese Provincia"
									v-model="request.province"
									@input="errorMessage = null"
								/>
							</div>

							<!-- Contact Name -->
							<base-input
								alternative
								name="contactName"
								label="Nombre de Contacto"
								class="tw-mt-3"
								label-classes="tw-px-3 tw-mb-1"
								group-class="mb-0 tw-bg-white tw-rounded tw-bg-opacity-60"
								:rules="{required: true}"
								placeholder="Ingrese Nombre de Contacto"
								v-model="request.contactName"
								@input="errorMessage = null"
							/>

							<!-- Phone Number -->
							<base-input
								alternative
								name="phoneNumber"
								label="Telefono Contacto"
								class="tw-mt-3"
								label-classes="tw-px-3 tw-mb-1"
								group-class="mb-0 tw-bg-white tw-rounded tw-bg-opacity-60"
								:rules="{required: true}"
								placeholder="Ingrese Telefono Contacto"
								v-model="request.phoneNumber"
								@input="errorMessage = null"
							/>

							<!-- Application Date -->
							<base-input
								alternative
								name="applicationDate"
								label="Fecha de Solicitud"
								class="tw-mt-3"
								label-classes="tw-px-3 tw-mb-1"
								group-class="mb-0 tw-bg-white tw-rounded tw-bg-opacity-60"
								:rules="{required: true}"
								v-model="request.applicationDate"
								@input="errorMessage = null"
							>
								<DateTimePicker
									class="tw-w-full"
									placeholder="Ingrese Fecha de Solicitud"
									v-model="request.applicationDate"
								></DateTimePicker>
							</base-input>

							<!-- Inspection Datetime -->
							<base-input
								alternative
								name="inspectionDateTime"
								label="Fecha y hora de Inspección"
								class="tw-mt-3"
								label-classes="tw-px-3 tw-mb-1"
								group-class="mb-0 tw-bg-white tw-rounded tw-bg-opacity-60"
								:rules="{required: true}"
								v-model="request.inspectionDateTime"
								@input="errorMessage = null"
							>
								<DateTimePicker
									type="datetime"
									class="tw-w-full"
									placeholder="Fecha y hora de Inspección"
									v-model="request.inspectionDateTime"
								></DateTimePicker>
							</base-input>

							<!-- Delivery Datetime -->
							<base-input
								alternative
								name="deliveryDateTime"
								label="Fecha y hora de Entrega"
								class="tw-mt-3"
								label-classes="tw-px-3 tw-mb-1"
								group-class="mb-0 tw-bg-white tw-rounded tw-bg-opacity-60"
								:rules="{required: true}"
								v-model="request.deliveryDateTime"
								@input="errorMessage = null"
							>
								<DateTimePicker
									type="datetime"
									class="tw-w-full"
									placeholder="Fecha y hora de Entrega"
									v-model="request.deliveryDateTime"
								></DateTimePicker>
							</base-input>

							<!-- Select Expert -->
							<base-input
								alternative
								name="Expert"
								label="Escoje un Perito"
								class="tw-mt-3"
								label-classes="tw-px-3 tw-mb-1"
								group-class="mb-0 tw-bg-white tw-rounded tw-bg-opacity-60"
								:rules="{ required: true }"
								v-model="request.expert"
								@input="errorMessage = null"
							>
								<multiselect
									label="name"
									track-by="id"
									placeholder="Escoje un Perito"
									:options="$expertAdmins.data"
									v-model="request.expert"
								></multiselect>
							</base-input>

							<!-- Documents -->
							<base-input
								alternative
								class="tw-mt-3"
								label-classes="tw-px-3 tw-mb-1"
								group-class="mb-0 tw-bg-white tw-rounded tw-bg-opacity-60"
								name="documents"
								label="Agregar Documentos"
								:rules="{ required: !isUpdate }"
							>
								<b-form-file
									multiple
									:state="isUpdate || Boolean(request.documents)"
									:value="request.documents[0]"
									@input="request.documents=$event"
									placeholder="Choose a file or drop it here..."
									drop-placeholder="Drop file here..."
									class="tw-border-none"
								></b-form-file>
							</base-input>

							<document-list>
								<document-list-item
									v-for="(doc, docIndex) in request.documents"
									:key="docIndex"
									:document="doc"
									:loading="loading"
									:uploading="!uploaded.includes(doc.name)"
								/>
							</document-list>

							<div class="text-center">
								<base-button
									class="my-4"
									type="secondary"
									native-type="submit"
									:loading="loading"
								>{{isUpdate?'Update':'Crear Solicitud'}}</base-button>
								<base-button type="danger" v-if="isUpdate" @click="onResetForm">Cancel</base-button>
							</div>
						</b-form>
					</validation-observer>
				</div>

				<!-- Divider -->
				<div class="tw-flex-none tw-w-1 tw-bg-white tw-bg-opacity-60 tw-rounded-full tw-mx-10 tw-my-16"></div>

				<div class="tw-flex-1 tw-text-justify tw-overflow-hidden">
					<h2 class="tw-text-3xl tw-font-bold tw-text-black">Solicitudes</h2>
					<data-table
						title
						export-type="full"
						:printable="false"
						:columns="headers"
						:rows="$requests"
						class="m-data-table tw-mt-7 tw-w-full tw-overflow-auto scrollbar-x tw-rounded"
					>
						<!-- v-on:row-click="onShowRequestInfo" -->
						<template v-slot:item.actions="{ item }">
							<td>
								<b-button-group size="sm" class="tw-shadow-none">
									<b-button variant="primary" @click="onShowRequestInfo(item)">View</b-button>
									<b-button variant="success" @click="onInitUpdateItem(item)">Update</b-button>
									<b-button variant="danger" @click="onDeleteItem(item)">Delete</b-button>
								</b-button-group>
							</td>
						</template>
					</data-table>
				</div>
			</div>
		</b-container>
		<modal-request-info @show="onShowRequestInfo = $event" />
	</div>
</template>
<script>
import 'vue2-datepicker/index.css';

import DataTable from "vue2-matable"
import DateTimePicker from 'vue2-datepicker';
import BaseHeader from '@/components/BaseHeader';
import ModalRequestInfo from '../components/Modals/ModalRequestInfo.vue'
import DocumentList from '../components/DocumentList.vue';
import DocumentListItem from '../components/DocumentListItem.vue';
import Multiselect from 'vue-multiselect'

import { mapActions, mapGetters, mapMutations } from 'vuex';
import { RequestsAPI } from '../firebase/api.firebase';

const initialRequest = (v = {}) => {
	return {
		id: v.id,
		client: v.client ? {
			id: v.client.id,
			client: v.client.name
		} : null,
		uniqueNumber: v.uniqueNumber || '',
		description: v.description || '',
		direction: v.direction || '',
		town: v.town || '',
		province: v.province || '',
		contactName: v.contactName || '',
		phoneNumber: v.phoneNumber || '',
		applicationDate: v.applicationDate && new Date(v.applicationDate),
		inspectionDateTime: v.inspectionDateTime && new Date(v.inspectionDateTime),
		deliveryDateTime: v.deliveryDateTime && new Date(v.deliveryDateTime),
		expert: v.expert,
		documents: [],
	}
}

export default {
	name: 'Requests',
	components: {
		BaseHeader,
		DataTable,
		DateTimePicker,
		ModalRequestInfo,
		DocumentList,
		DocumentListItem,
		Multiselect
	},
	data: () => ({
		onShowRequestInfo: () => { },
		loading: false,
		uploaded: [],
		request: initialRequest(),
		headers: [
			{ field: 'client.name', label: 'Cliente' },
			{ field: 'uniqueNumber', label: 'Numero Unico' },
			{ field: 'description', label: 'Descripcion' },
			{ field: 'direction', label: 'Direccion' },
			{ field: 'town', label: 'Ciudad' },
			{ field: 'province', label: 'Provincia' },
			{ field: 'actions', label: 'Actions' },
		],
	}),
	computed: {
		...mapGetters('requests', ['$request', '$requests', '$clients', '$expertAdmins']),
		...mapGetters('experts', ['$experts']),
		isUpdate() {
			return !!this.$request.id
		}
	},
	created() {
		this.getClients()
		this.getExpertAdmins()
		this.subscribeRequests()
	},
	watch: {
		'$request.id': {
			immediate: true,
			handler(id) {
				if (!id) return
				this.request = initialRequest(this.$request)
			}
		}
	},
	methods: {
		...mapMutations('requests', ['SET']),
		...mapActions('experts', ['subscribeExperts']),
		...mapActions('requests', ['subscribeRequests', 'getClients', 'getExpertAdmins', 'deleteRequest']),
		async onSubmit() {

			this.loading = true
			const documents = await RequestsAPI
				.uploadFiles(this.request.documents, (doc, file) => {
					this.uploaded.push(file.name)
				})

			const data = {
				...this.request,
				documents: this.isUpdate
					? this.$request.documents.concat(documents)
					: documents,
				client: {
					id: this.request.client.id,
					name: this.request.client.client,
				},
				expert: {
					id: this.request.expert.id,
					name: this.request.expert.name,
				},
				applicationDate: this.$m(this.request.applicationDate).utc().valueOf(),
				inspectionDateTime: this.$m(this.request.applicationDate).utc().valueOf(),
				deliveryDateTime: this.$m(this.request.applicationDate).utc().valueOf(),
			}

			if (!this.isUpdate) delete data.id

			const promise = this.isUpdate
				? RequestsAPI.update(data.id, data)
				: RequestsAPI.save(data)

			let [err] = await promise
			this.loading = false

			if (!err) {
				this.uploaded = []
				this.request = initialRequest()
				this.$refs.formValidator.reset()
			}
		},
		onResetForm() {
			this.request = initialRequest()
			this.$refs.formValidator.reset()
			this.SET({ request: { id: null } })
			this.loading = false
		},
		onInitUpdateItem(item) {
			this.SET({ request: item })
		},
		onDeleteItem(item) {
			if (confirm('Do you want to delete this item?')) {
				this.deleteRequest(item.id)
			}
		},
	}
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang='scss'>
	.mx-datepicker {
		input {
			height: 44px;
			border: none;
		}
	}
</style>
